import React from "react";
import styles from "./Real.module.css";
import improveImg from "../../assets/our.jpg";
import img1 from "../../assets/gallery-img12.jpg";
import img2 from "../../assets/gallery-img10.jpg";
import img3 from "../../assets/gallery-img13.jpg";

const Real = () => {
  return (
    <div className="mb-5 mt-5 overflow-hidden tournament">
      <div className="container">
        <div className="row g-0">
          <div
            className={`col-md-6 ${styles.imgDiv}`}
            data-aos="slide-right"
            data-aos-offset="190"
          >
            <div className="container">
              <img src={improveImg} alt="" className={styles.img} />
            </div>
            <div className="row ">
              <div className="col-md-4 col-sm-6 mt-4">
                {" "}
                <img src={img1} alt="" className={styles.img} />
              </div>
              <div className="col-md-4 col-sm-6 mt-4">
                {" "}
                <img src={img2} alt="" className={styles.img} />
              </div>
              <div className="col-md-4 col-sm-6 mt-4">
                {" "}
                <img src={img3} alt="" className={styles.img} />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className={styles.text}>
              <p
                data-aos="slide-right"
                data-aos-offset="150"
                className={styles.heading}
              >
                Our special
              </p>
              <p
                data-aos="slide-left"
                data-aos-offset="150"
                className={styles.subHeading}
              >
                The Region's Biggest Pool Tournament{" "}
              </p>
              <p
                data-aos="zoom-in"
                data-aos-offset="150"
                className={styles.content}
              >
                Responsive web design supply chain crowdfunding agile
                development analytics technology ownership startup. Network
                effects social proof user experience prototype buzz product
                management deployment metrics sales infographic equity holy
                grail crowdfunding release.{" "}
              </p>
              <div data-aos="zoom-in" style={{ textAlign: "left" }}>
                <button className={`btn custom_btn ${styles.btn}`}>
                  LET&apos;S TALK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Real;
